import React from 'react'
import { Box, Flex, Menu } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import UnderLine from '../UnderLine/UnderLine'
import useMenuLink from './hooks/useMenuLink'
import CustomMenuButton from './components/CustomMenuButton'
import CustomMenuList from './components/CustomMenuList'

export default function MenuLink({
  parentLink,
  links,
  onClick,
  showUnderLine,
}) {
  const { isOpen, openMenu, closeMenu, retardedClose } = useMenuLink({
    parentLink,
    links,
  })

  return (
    <Flex
      direction="column"
      h="100%"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <Menu zIndex={100} placement="bottom" isOpen={isOpen}>
        <div onMouseLeave={retardedClose}>
          <CustomMenuButton
            zIndex={100}
            parentLink={parentLink}
            openMenu={openMenu}
            onClick={onClick}
          />
          <CustomMenuList
            parentLink={parentLink}
            closeMenu={closeMenu}
            openMenu={openMenu}
            links={links}
            onClick={onClick}
          />
        </div>
      </Menu>
      <Box position="absolute" bottom="-6px" left={-1}>
        {showUnderLine && <UnderLine />}
      </Box>
    </Flex>
  )
}

MenuLink.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  onClick: PropTypes.func,
  parentLink: PropTypes.object,
  showUnderLine: PropTypes.bool,
}
